import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnFloatBtnComponent } from './fn-float-btn.component';

export * from './fn-float-btn.component';
export * from './fn-float-btn.model';

@NgModule({
	declarations: [FnFloatBtnComponent],
	imports: [CommonModule],
	exports: [FnFloatBtnComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class FnFloatBtnModule {}
